/**
 * What the paste box shows of pasted markup: its table rebuilt from the cells'
 * text, or its text when there is no table. The pasted markup itself never
 * enters the page, so nothing it carries can run there.
 */
export function plainCopy(pasted: Document): Node {
  const rows = pasted.querySelectorAll('tr');
  if (rows.length === 0) return document.createTextNode(pasted.body.textContent ?? '');

  const table = document.createElement('table');
  rows.forEach((row) => {
    const copy = table.insertRow();
    row.querySelectorAll('td, th').forEach((cell) => {
      const td = document.createElement(cell.tagName === 'TH' ? 'th' : 'td');
      td.className = 'pr-4 text-left';
      td.textContent = cell.textContent;
      copy.append(td);
    });
  });
  return table;
}
